import { XMLExporter } from 'substance'

export default
class TextureArticleExporter extends XMLExporter {

}
